import { CaretDownIcon } from '@/components/icons/CaretDownIcon'
import { useIsMobile } from '@/hooks/use-is-mobile'
import { useTranslations } from 'next-intl'
import { Accordion } from 'radix-ui'

import { TServiceType } from '../types'
import { ProvidersCardList } from './providers-card-list'
import { ProvidersTable } from './providers-table'

interface IServiceAccordionProps {
  title: string
  value: string
  defaultOpen?: boolean
  type: TServiceType
}

export function ServiceAccordion({
  title,
  value,
  defaultOpen = false,
  type
}: IServiceAccordionProps) {
  const t = useTranslations('Services')
  const isMobile = useIsMobile()

  return (
    <Accordion.Root
      type="single"
      collapsible
      defaultValue={defaultOpen ? value : undefined}
    >
      <Accordion.Item value={value} className="rounded-[20px] bg-gray-50 px-4">
        <Accordion.Header asChild>
          <Accordion.Trigger className="group ring-primary-500 flex w-full cursor-pointer items-center gap-4 py-3 text-left transition-all ease-in">
            {type.icon && (
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white md:mb-1">
                {type.icon}
              </span>
            )}
            <span className="text-primary-600 text-body-3 font-bold">
              {t(title)}
            </span>
            <CaretDownIcon
              className="ml-auto transition-transform duration-200 group-data-[state=open]:rotate-180"
              size="28px"
            />
          </Accordion.Trigger>
        </Accordion.Header>
        <Accordion.Content className="accordion-content overflow-hidden">
          {isMobile ? (
            <ProvidersCardList type={type} />
          ) : (
            <ProvidersTable type={type} />
          )}
          {type.notes && (
            <div className="text-body-3 text-primary-400 space-y-2 pb-4">
              {type.notes.map((note) => (
                <p key={note}>{t(note)}</p>
              ))}
            </div>
          )}
        </Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  )
}
